<!-- 
A text field for entering currency.
-->
<template>
  <v-text-field
    :value="currencyFormatted"
    :label="label"
    :rules="[required ? rules.required : rules.empty, rules.number, zeroOrGreater ? rules.zeroOrGreater : rules.empty, max ? rules.max : rules.empty]"
    :autofocus="autofocus"
    :hint="hint"
    :persistent-hint="persistentHint"
    :append-icon="appendIcon"
    :readonly="readonly"
    prefix="$"
    @click:append="$emit('click:append')"
    @input="changed"
    @focus="gotFocus"
    @blur="lostFocus"
  >
    <template v-if="hasLabelSlot" slot="label">
      <slot name="label"/>
    </template>
  </v-text-field>
</template>

<script>
import ruleMixins from "@/mixins/rule.mixins";
import * as ruleHelper from "@/helpers/rule.helper";
import * as formatting from "@/helpers/formatting.helper";

export default {
  mixins: [ruleMixins],
  props: {
    value: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null,
      required: true
    },
    label: {
      default: "",
      type: String
    },
    required: {
      default: false,
      type: Boolean
    },
    zeroOrGreater: {
      default: false,
      type: Boolean
    },
    autofocus: {
      default: false,
      type: Boolean
    },
    hint: {
      default: null,
      type: String
    },
    persistentHint: {
      default: false,
      type: Boolean
    },
    readonly: {
      default: false,
      type: Boolean
    },
    max: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null,
      default: null
    },
    appendIcon: {
      default: undefined,
      validator: prop => typeof prop === "string" || prop === undefined
    }
  },
  data() {
    return {
      hasFocus: false,
      rules: {
        max: v =>
          v && ruleHelper.roundNumber(v, 2) > this.max
            ? `Value must be less than ${formatting.currency(this.max)}`
            : true
      }
    };
  },
  computed: {
    currencyFormatted() {
      if (this.value === null) {
        return null;
      }
      const isNumber = this.rules.number(this.value) === true;
      return this.hasFocus || !isNumber ? this.value : formatting.currency(this.value, "");
    },
    hasLabelSlot() {
      return !!this.$slots["label"];
    }
  },
  watch: {
    hasFocus(nowHasFocus) {
      if (!nowHasFocus) {
        this.changed(this.value);
      }
    }
  },
  methods: {
    changed(d) {
      if (d && this.rules.number(d) === true && !this.hasFocus) {
        this.$emit("input", ruleHelper.roundNumber(d, 2));
      } else {
        this.$emit("input", d);
      }
    },
    gotFocus() {
      this.hasFocus = true;
    },
    lostFocus() {
      this.hasFocus = false;
    }
  }
};
</script>
